var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.formComponent(_vm.question.type),{tag:"component",attrs:{"questionId":_vm.questionId,"itemObj":_vm.itemObj,"pageBack":_vm.pageBack,"focus":_vm.focus}})
}
var staticRenderFns = []

export { render, staticRenderFns }